import React from 'react';
import { MdArrowUpward, MdArrowDownward } from 'react-icons/md';
import { KpiTileProps } from './types';
import {
  Container,
  Title,
  Value,
  SecondTitle,
  Subtitle,
  TagContainer,
  TagRow,
  Label,
  Tag,
  ArrowIcon,
} from './style';

const KpiTile: React.FC<KpiTileProps> = ({ data, rest }) => {
  const { title, secondTitle, value, tag: tags, subTitle } = data;

  // Function to render each tag
  const renderTag = (tagItem: any, index: number) => {
    const arrowReversed = tagItem.arrowReversed ?? false;
    const ArrowComponent = tagItem.isPositiveValue
      ? arrowReversed
        ? MdArrowDownward
        : MdArrowUpward
      : arrowReversed
        ? MdArrowUpward
        : MdArrowDownward;

    const tagValue =
      (tagItem.showArrow ?? true) ? (
        <span>
          {tagItem.text}{' '}
          <ArrowIcon>
            <ArrowComponent />
          </ArrowIcon>
        </span>
      ) : (
        <span>{tagItem.text}</span>
      );

    // Check if color is a valid non-empty string
    const hasValidColor = tagItem.color && tagItem.color.trim() !== '';

    // Determine class-based styling (only used if no custom color)
    const tagClassName = hasValidColor
      ? undefined
      : tagItem.sideLabel?.toLowerCase() === 'target'
        ? 'target'
        : tagItem.isPositiveValue
          ? 'positive'
          : 'negative';

    // Custom style for color override
    const tagStyle = hasValidColor
      ? { backgroundColor: tagItem.color }
      : undefined;

    return (
      <TagRow key={index}>
        <Tag
          data-kpi-badge
          className={tagClassName}
          style={tagStyle}
          data-testid={`tile-tag-${index}`}
        >
          {tagValue}
        </Tag>
        {tagItem.sideLabel && (
          <Label data-testid={`tile-tag-label-${index}`}>
            {tagItem.sideLabel}
          </Label>
        )}
      </TagRow>
    );
  };

  return (
    <Container data-testid="tile-container">
      <Value
        data-testid="tile-value"
        dangerouslySetInnerHTML={{ __html: value as string }}
      />
      <Title data-testid="tile-title">{title}</Title>
      {secondTitle && (
        <SecondTitle data-testid="tile-second-title">{secondTitle}</SecondTitle>
      )}
      {tags && Array.isArray(tags) && tags.length > 0 && (
        <TagContainer data-testid="tile-tag-container">
          {tags.map((tagItem, index) => renderTag(tagItem, index))}
        </TagContainer>
      )}
      {subTitle && <Subtitle data-testid="tile-subtitle">{subTitle}</Subtitle>}
      {rest &&
        rest.map((component, index) => (
          <React.Fragment key={index}>{component}</React.Fragment>
        ))}
    </Container>
  );
};

export default KpiTile;
